import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { WorkspaceForTable } from '../types'
import { mapFromDTO, sortToDTO } from './mapper'
import { GET_WORKSPACES_FOR_TABLE } from './query'
import {
  Data,
  UseGetWorkspaces,
  UseGetWorkspacesProps,
  Variables,
  WorkspaceForTableDTO,
} from './types'

export const useGetWorkspaces = ({
  filters,
  first,
  last,
  sort,
}: UseGetWorkspacesProps): UseGetWorkspaces => {
  const [workspaces, setWorkspaces] = useState<WorkspaceForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        workspaces: { nodes: workspaces, totalCount: count },
      } = data

      if (workspaces) {
        setWorkspaces(
          workspaces.map(
            (workspace: WorkspaceForTableDTO): WorkspaceForTable => mapFromDTO(workspace),
          ),
        )
        setCount(count)
      }
    },
    query: GET_WORKSPACES_FOR_TABLE,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
    },
  })

  return {
    count,
    loading,
    workspaces,
  }
}
